<template>
  <div>
    <DesktopHistory
      :pastOrders="pastOrders"
      :orderBagde="orderBagde"
      :brandLogo="brandLogo"
      :orderDate="orderDate"
      @reOrder="fetchAndNavigate"
    />
    <MobileHistory
      :pastOrders="pastOrders"
      :orderBagde="orderBagde"
      :brandLogo="brandLogo"
      :orderDate="orderDate"
      @reOrder="fetchAndNavigate"
    />
  </div>
</template>
<script>
import DesktopHistory from './DesktopHistory'
import MobileHistory from './MobileHistory'

import * as utils from '@/utils/main_utils'
import { Item } from '@/helpers/Item'
import { mapGetters } from 'vuex'
export default {
  name: 'History',
  components: {
    DesktopHistory,
    MobileHistory,
  },
  computed: {
    ...mapGetters([
      'all_customer_orders',
      'find_brand_by_main_id',
      'brandStoreRoute',
      'selected_order',
    ]),
    pastOrders() {
      if (this.all_customer_orders) {
        let filteredOrders = this.all_customer_orders.filter(order => {
          return (
            order.order_status === this.CONST.ORDER_STATUS_FINISHED ||
            order.order_system_status ===
              this.CONST.ORDER_SYSTEM_STATUS_REJECTED ||
            order.order_system_status ===
              this.CONST.ORDER_SYSTEM_STATUS_CANCELLED
          )
        })
        return filteredOrders
      }
      return []
    },
  },
  methods: {
    orderDate(date) {
      if (date) {
        return utils.datetime_in_local_timezone(date)
      }
    },
    orderBagde(orderStatus) {
      switch (orderStatus.toUpperCase()) {
        case 'BOOKING COMPLETE':
        case 'FINISHED':
          return 'badge-process'
        case 'PICKED UP':
        case 'IN-PROGRESS':
          return 'badge-delayed'
        case 'CANCELLED':
        case 'REJECTED':
          return 'badge-cancle'
        default:
          return 'badge-delivered'
      }
    },
    brandLogo(brandId, prop) {
      if (brandId) {
        const currentBrand = this.find_brand_by_main_id(brandId)
        if (currentBrand) {
          return currentBrand[prop]
        }
        return {}
      }
      return {}
    },
    async fetchAndNavigate(pastOrder) {
      const that = this
      that.$store.dispatch('startProcess', {
        process: 'route-change',
        progress: true,
      })
      const orderId = pastOrder._id
      that.$store.commit('CLEAR_CHECKOUT')
      await Item.clearCart()
      await that.$store.dispatch('getOrderById', orderId)
      await that.$store.dispatch('loadCatalog')
      that.$store
        .dispatch('reAddItemsToCart', that.selected_order.items)
        .then(() => {
          that.$router.push({
            name: this.brandStoreRoute('store_page'),
            params: {
              brand_id: that.selected_order.brand_id,
              store_id: that.selected_order.store_id,
            },
          })
          that.$store.dispatch('stopProcess', 'route-change')
        })
    },
  },
  beforeMount() {
    this.$store.dispatch('load_orders', true)
  },
}
</script>
